import moment from "moment";

export function CommentModel(data) {
    const { author, chatFiles, created_at, id, is_delete, message, parent_id } = data;

    const { user, worker } = author;

    return {
        id,
        createdAt: moment(created_at).format("DD.MM.YYYY HH:mm"),

        message,
        parent: parent_id,

        files: chatFiles,

        user,
        worker,

        deleted: !!is_delete,

        answers: [],
    };
}

export function updateComment(comment, updatedData) {
    const { message, chatFiles } = updatedData;

    comment.message = message;
    comment.files = chatFiles;
}
